const initialState: string = API_BASE_URL;

export default function (state: string = initialState): string {
  return state;
}
